/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a2d52bf4def7f4040090680123f17406a5310cd5";
